import { serializable, alias, primitive } from "serializr";

export class LiveClassParticipants {
  @serializable(alias("live_class_id", primitive()))
  liveClassId?: number;
}
